type IconProps = {
	width?: number;
	height?: number;
	color?: string;
}

export const CircleIcon = (props: IconProps) => {
	const {
		width =  6,
		height = 6,
		color = '#D9D9D9',
	} = props;
	return (
		<svg  role={'img'} height={height} width={width} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='none'>
			<circle cx='3' cy='3' r='3' fill={color}/>
		</svg>
	);
};